module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step1_Image10.736f5427.jpg";